import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import quantaLogo from "../assets/quanta.png";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [form, setForm] = useState({ email: "", password: "", licenseKey: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const result = await login(form.email, form.password, form.licenseKey);
      const redirectUrl = params.get("redirectUrl");
      navigate(result.requiresCompanySetup ? "/company-setup" : redirectUrl || "/dashboard", { replace: true });
    } catch (err) {
      setError(err.userMessage || err.response?.data || "Invalid login details");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center p-3" style={{ background: "linear-gradient(135deg, #22052D 0%, #CCB3D1 100%)" }}>
      <div className="row g-0 shadow-lg overflow-hidden" style={{ width: "min(940px, 100%)", borderRadius: 24, background: "rgba(255,255,255,.96)" }}>
        <div className="col-lg-6 d-none d-lg-flex flex-column justify-content-between p-4 text-white" style={{ background: "linear-gradient(160deg, #22052D, #5f2a6d)" }}>
          <div>
            <img src={quantaLogo} alt="Quanta ERP" style={{ width: "78%", maxWidth: 300, height: "auto", marginLeft: -12 }} />
            <h3 className="fw-bold mt-3">Quanta ERP</h3>
            <p className="small mb-0" style={{ opacity: .85 }}>Accounting, inventory, GST, payroll and business reports in one secure workspace.</p>
          </div>
          <div className="row g-2 small">
            {["GST Ready", "Secure Login", "Company Wise", "Auto Vouchers"].map((x) => <div className="col-6" key={x}><div className="rounded-4 p-2" style={{ background: "rgba(255,255,255,.12)" }}><i className="bi bi-check2-circle me-1"></i>{x}</div></div>)}
          </div>
        </div>
        <div className="col-lg-6 p-4 p-md-5">
          <div className="mb-4">
            <div className="badge rounded-pill mb-2" style={{ background: "#22052D" }}>Secure ERP Login</div>
            <h4 className="fw-bold mb-1">Welcome back</h4>
            <p className="text-muted small mb-0">Login to manage accounts, vouchers, inventory and reports.</p>
          </div>
          {error && <div className="alert alert-danger py-2 small">{String(error)}</div>}
          <form onSubmit={submit} className="d-grid gap-3">
            <div>
              <label className="form-label small fw-semibold">Email</label>
              <div className="input-group input-group-sm">
                <span className="input-group-text"><i className="bi bi-envelope"></i></span>
                <input type="email" className="form-control" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="admin@company.com" required />
              </div>
            </div>
            <div>
              <label className="form-label small fw-semibold">Password</label>
              <div className="input-group input-group-sm">
                <span className="input-group-text"><i className="bi bi-shield-lock"></i></span>
                <input type="password" className="form-control" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Enter your password" required />
              </div>
            </div>
            <div>
              <label className="form-label small fw-semibold">License Key optional</label>
              <input className="form-control form-control-sm" value={form.licenseKey} onChange={(e) => setForm({ ...form, licenseKey: e.target.value })} placeholder="Paste demo/full license key if required" />
            </div>
            <button className="btn btn-sm text-white py-2" style={{ background: "linear-gradient(90deg, #22052D, #CCB3D1)", border: 0, borderRadius: 10 }} disabled={loading}>
              {loading ? <><span className="spinner-border spinner-border-sm me-2" />Signing in...</> : <><i className="bi bi-box-arrow-in-right me-2"></i>Login</>}
            </button>
          </form>
          <div className="small text-center mt-4">New ERP setup? <Link to="/register" className="fw-semibold">Create admin account</Link></div>
        </div>
      </div>
    </div>
  );
}
